import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router';
import ApplicationRoutes from '../../helpers/ApplicationRoutes';

const RedirectToNow = ({ organizationId }) => {
    const now = new Date();
    const year = now.getFullYear();
    const month = (now.getMonth() + 1).toString().padStart(2, '0');
    const date = now
        .getDate()
        .toString()
        .padStart(2, '0');
    const start = `${year}-${month}-01`;
    const end = `${year}-${month}-${date}`;
    return (
        <Redirect
            to={ApplicationRoutes.organizationReportQuery.getPath({
                start,
                end,
                organizationId,
            })}
        />
    );
};

RedirectToNow.propTypes = {
    organizationId: PropTypes.number.isRequired,
};

export default RedirectToNow;



// WEBPACK FOOTER //
// ./src/components/report/RedirectToNow.js